<script setup>
import { ref, watch } from 'vue'
import { useI18n } from 'vue-i18n'
import { Card } from '@drama/ui'
import { api, inGuild, currentGuild } from '../api.js'

const { t } = useI18n()
const connections = ref([])
const loaded = ref(false)
const error = ref('')
watch(() => currentGuild.slug, async () => {
  loaded.value = false
  error.value = ''
  try { connections.value = (await api('GET', inGuild('/api/voko/work/sync-connections'))).connections } catch (err) { error.value = err.message }
  loaded.value = true
}, { immediate: true })
const when = (iso) => new Date(iso).toLocaleString()
</script>

<template>
  <Card>
    <h2>{{ t('okr.sync.title') }}</h2>
    <p v-if="error" role="alert">{{ error }}</p>
    <template v-if="loaded && error === ''">
      <p v-if="connections.length === 0">{{ t('okr.sync.notConnected') }}</p>
      <template v-for="connection in connections" :key="connection.id">
        <p>{{ t('okr.sync.connected', { slug: connection.tree_slug }) }}</p>
        <p>{{ connection.last_synced_at === null ? t('okr.sync.neverSynced') : t('okr.sync.lastSynced', { time: when(connection.last_synced_at) }) }}</p>
        <p v-if="connection.last_error !== null" role="alert">{{ connection.last_error }}</p>
        <p v-if="connection.conflicts > 0" role="alert">{{ t('okr.sync.conflicts', { n: connection.conflicts }) }}</p>
      </template>
    </template>
  </Card>
</template>
